import { BUSINESS } from "@/data/business";
import { Phone, MessageCircle, MapPin, Mail, Clock } from "lucide-react";
import { Reveal } from "./Reveal";

const Footer = () => {
  return (
    <footer data-testid="site-footer" className="bg-[#141414] text-white pt-20 sm:pt-24 pb-10">
      <div className="container-nitc">
        <div className="grid lg:grid-cols-12 gap-12">
          <Reveal className="lg:col-span-5">
            <div className="flex items-center gap-3">
              <div className="h-12 w-12 rounded-full bg-white ring-1 ring-white/15 flex items-center justify-center overflow-hidden">
                <img src={BUSINESS.logo} alt="NITC" className="h-10 w-10 object-contain" />
              </div>
              <div>
                <p className="font-display text-xl font-semibold leading-none">New India</p>
                <p className="text-[11px] tracking-[0.22em] uppercase text-white/60 mt-1">
                  Trading Corporation
                </p>
              </div>
            </div>
            <p className="mt-7 text-white/70 leading-relaxed max-w-md text-sm">
              {BUSINESS.tagline}. {BUSINESS.yearsExperience}+ years of wholesale &amp; retail dealing in
              plywood, laminates and allied interior materials — with pan-India delivery.
            </p>

            <div className="mt-8 flex flex-wrap gap-3">
              <a
                href={`tel:${BUSINESS.phoneRaw}`}
                data-testid="footer-call"
                className="inline-flex items-center gap-2 bg-white text-[#141414] hover:bg-white/90 text-sm font-medium px-5 py-3 rounded-md transition-colors"
              >
                <Phone className="h-4 w-4" /> Call
              </a>
              <a
                href={`https://wa.me/${BUSINESS.whatsappRaw}`}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-whatsapp"
                className="inline-flex items-center gap-2 bg-[#25D366] text-[#0a0a0a] hover:bg-[#1ebe57] text-sm font-medium px-5 py-3 rounded-md transition-colors"
              >
                <MessageCircle className="h-4 w-4" /> WhatsApp
              </a>
              <a
                href={BUSINESS.mapsUrl}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-maps"
                className="inline-flex items-center gap-2 border border-white/20 hover:border-white text-sm font-medium px-5 py-3 rounded-md transition-colors"
              >
                <MapPin className="h-4 w-4" /> Maps
              </a>
            </div>
          </Reveal>

          <Reveal delay={0.08} className="lg:col-span-4">
            <p className="text-eyebrow text-white" style={{ color: "#C9A07A" }}>
              Visit our showroom
            </p>
            <div className="mt-5 space-y-4 text-sm text-white/80">
              <div className="flex gap-3">
                <MapPin className="h-4 w-4 mt-0.5 text-white/60 shrink-0" />
                <span className="leading-relaxed">{BUSINESS.address}</span>
              </div>
              <div className="flex gap-3 items-center">
                <Phone className="h-4 w-4 text-white/60" />
                <a href={`tel:${BUSINESS.phoneRaw}`} className="hover:text-white">{BUSINESS.phone}</a>
              </div>
              <div className="flex gap-3 items-center">
                <Mail className="h-4 w-4 text-white/60" />
                <a href={`mailto:${BUSINESS.email}`} className="hover:text-white">{BUSINESS.email}</a>
              </div>
              <div className="flex gap-3 items-center">
                <Clock className="h-4 w-4 text-white/60" />
                <span>{BUSINESS.hours} (Mon–Sun)</span>
              </div>
            </div>

            <div className="mt-7 text-xs text-white/50 space-y-1.5">
              <p><span className="text-white/70">GST:</span> {BUSINESS.gst}</p>
              <p><span className="text-white/70">Founder:</span> {BUSINESS.founder}</p>
              <p><span className="text-white/70">Type:</span> {BUSINESS.type} · Pan India</p>
            </div>
          </Reveal>

          <Reveal delay={0.16} className="lg:col-span-3">
            <p className="text-eyebrow" style={{ color: "#C9A07A" }}>Location</p>
            <div className="mt-5 rounded-lg overflow-hidden ring-1 ring-white/10 aspect-[4/3]">
              <iframe
                title="NITC Map"
                src={BUSINESS.embedMap}
                className="w-full h-full"
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                allowFullScreen
              />
            </div>
          </Reveal>
        </div>

        <div className="mt-16 pt-8 border-t border-white/10 flex flex-col sm:flex-row justify-between gap-4 text-xs text-white/50">
          <p>© {new Date().getFullYear()} New India Trading Corporation. All rights reserved.</p>
          <p>
            Plywood dealer · Laminate shop · Wholesale plywood supplier · Formica sheets dealer ·
            Bangalore
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
